export default __webpack_public_path__ + "static/media/gallery_01.5afafe6a.jpg";